import React from "react";
import { UiButton } from "../common/UiButton";
import { Trans } from "react-i18next";

export const SomethingWrongModal = (props) => {
  return (
    <>
      <div
        className={
          props?.className ? props?.className : "df-confirmation-message-popup"
        }
      >
        {props?.icon}
        {props?.message && (
          <h3 className="df-confirmation-message-popup__message">
            {props?.isTransAvailable ? (
              <Trans i18nKey={props?.message} />
            ) : (
              <>{props?.message}</>
            )}
          </h3>
        )}
        {props?.children}
        <UiButton
          className={
            props?.buttonClass ? props?.buttonClass : "df-ui-dark-bg-btn"
          }
          name={props?.buttonText}
          onClick={props?.buttonOnClick}
          disabled={props?.disabled}
        />
      </div>
    </>
  );
};
